module.exports = __webpack_public_path__ + "static/media/mc_controls_panel.dc34e5a8.svg";